import React from 'react';
import Layout from '../Components/Layout';

const withLayout = (Component: React.ComponentType) => {
  return () => (
    <Layout>
      <Component />
    </Layout>
  );
};

export default withLayout;